<template>
  <ai-specification :specification="specification" :variant="variant" />
</template>

<script setup lang="ts">
import type { AiSpecification } from '~~/domains/ux/organisms/AiSpecification/types';

export interface HotelSpecificationProps {
  specification: AiSpecification[];
  variant: 'positive' | 'inverse';
}

defineProps<HotelSpecificationProps>();
</script>
